import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../enums'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.rate.gl.Filter.Comparison,
  graphql.schema.GeneralLedgerFilterComparisonInput
>({
  attributeId: transformers.PASS_THROUGH,
  operator: graphql.transformers.IN.nonNull(
    enums.comparisonOperator.TRANSFORMER,
  ),
  value: raw => JSON.stringify(raw.value),
})
